/** Pollards' main line, for the places that tell a customer to ring us. */
export const POLLARDS_PHONE = "01752 663111";
